import { HtmlId } from '../enum';
import { Button, createButton } from '@vfde-brix/ws10/button';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { CmsAvailabilityButton } from '../interface';
import { ProductAvailability } from '../container/AddressValidation/interface';
import buttonUtils from '../util/component/button.utils';
import { AddressValidationActions } from '../container/AddressValidation';

/**
 * Create Brix Button component.
 * @param {HtmlId} id - ID of the element.
 * @returns {Button | null} component or null if element with given id is not found
 */
export const mountButton = (id: HtmlId) =>
    createComponentById(createButton, id, NO_PATTERN_BUSINESS_LOGIC);

export const updateResultButton = (
    comp: Button | null,
    cmsProps: CmsAvailabilityButton,
    actions: AddressValidationActions,
    availability: ProductAvailability,
    selectedId?: string,
) => {
    if (!comp || !selectedId) {
        return;
    }

    const props = comp.getProperties();

    props.business.onClick = buttonUtils.getResultAction(actions, availability);
    props.linkHref = buttonUtils.getResultLink(availability, selectedId);
    props.stdContent = buttonUtils.getResultText(cmsProps, availability);

    comp.update(props);
};
